export default __webpack_public_path__ + "static/media/order.eccdbcd1.png";